
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BoardListFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BoardList"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BoardListShared"},"directives":[]}]}}],"loc":{"start":0,"end":113}};
    doc.loc.source = {"body":"#import \"./board_list_shared.fragment.graphql\"\n\nfragment BoardListFragment on BoardList {\n  ...BoardListShared\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./board_list_shared.fragment.graphql").definitions));


      module.exports = doc;
    
